import styled, { css } from 'styled-components';

import { slide } from 'app/theme/animations/slide';

const Loader = styled.div<{ $isLoading: boolean }>`
  width: 100%;
  height: 0.5rem;
  position: relative;
  overflow: hidden;

  ${({ $isLoading }) =>
    $isLoading &&
    css`
      ::after {
        position: absolute;
        animation: ${slide} 2s linear infinite;
        content: ' ';
        width: 30%;
        height: 100%;
        background-color: ${({ theme }) => theme.palette.primary};
      }
    `}
`;

export const LinearLoader = ({ $isLoading }: { $isLoading: boolean }): JSX.Element => (
  <Loader $isLoading={$isLoading} data-testid="loader" />
);
